import {
  warningCardHeader,
  successCardHeader,
  dangerCardHeader,
  infoCardHeader,
  primaryCardHeader,
  roseCardHeader,
} from "assets/jss/material-dashboard-pro-react.js";
import {
  secondaryColor, primaryColor, infoColor
} from "@themes/defaultThemeProps";

const cardIconStyle = {
  cardIcon: {
    "&$warningCardHeader,&$successCardHeader,&$dangerCardHeader,&$infoCardHeader,&$primaryCardHeader,&$roseCardHeader": {
      borderRadius: "3px",
      padding: "15px",
      marginTop: "-20px",
      marginRight: "15px",
      float: "left",
      backgroundColor: infoColor[0],
    },
    "&$primaryCardHeader": {
      backgroundColor: infoColor[0],
    },
    "&$dangerCardHeader": {
      backgroundColor: infoColor[1],
    },
    "&$infoCardHeader": {
      backgroundColor: infoColor[2],
    },
    "&$warningCardHeader": {
      backgroundColor: infoColor[3],
    },
  },
  warningCardHeader,
  successCardHeader,
  dangerCardHeader,
  infoCardHeader,
  primaryCardHeader,
  roseCardHeader
};

export default cardIconStyle;
